import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FolderIcon from '@mui/icons-material/Folder';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/**
 * Standalone dropdown menu for source package folder selection.
 * Uses MUI Menu (closes on click-away).
 * Shows root + last 3 folders + "Choose another..." option.
 */
export default function SourcePackageDropdownMenu({
                                                      open,
                                                      anchorEl,
                                                      folderList,
                                                      onAddToRoot,
                                                      onAddToFolder,
                                                      onChooseAnother,
                                                      onClose,
                                                  }) {
    const truncateText = (text, maxLength = 40) => {
        if (!text) return 'Untitled';
        return text.length > maxLength ? text.slice(0, maxLength - 3) + '…' : text;
    };

    // Get last 3 suggested folders
    const suggestedFolders = [...(folderList || [])].slice(-3).reverse();

    return (
        <Menu
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
            transformOrigin={{vertical: 'top', horizontal: 'left'}}
            slotProps={{paper: {sx: {zIndex: 10000}}}}
        >
            {/* Root option */}
            <MenuItem
                onClick={() => {
                    onAddToRoot();
                    onClose();
                }}
                sx={{py: 1}}
            >
                <ListItemIcon sx={{minWidth: 32}}>
                    <FolderIcon fontSize="small" color="primary"/>
                </ListItemIcon>
                <ListItemText primary="Root (Top level)"/>
            </MenuItem>

            {/* Suggested folders */}
            {suggestedFolders.length > 0 && [
                <ListSubheader key="suggested-header" disableSticky
                               sx={{lineHeight: '28px', fontSize: '0.75rem'}}>
                    Suggested
                </ListSubheader>,
                ...suggestedFolders.map((folder) => (
                    <MenuItem
                        key={folder.id}
                        onClick={() => {
                            onAddToFolder(folder.id);
                            onClose();
                        }}
                        sx={{py: 1}}
                    >
                        <ListItemIcon sx={{minWidth: 32}}>
                            <FolderIcon fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText primary={truncateText(folder.name || 'Untitled')}/>
                    </MenuItem>
                ))
            ]}

            <Divider sx={{my: 0.5}}/>

            {/* Choose another option */}
            <MenuItem
                onClick={() => {
                    onChooseAnother();
                }}
                sx={{py: 1}}
            >
                <ListItemIcon sx={{minWidth: 32}}>
                    <MoreHorizIcon fontSize="small"/>
                </ListItemIcon>
                <ListItemText
                    primary="Choose another..."
                    slotProps={{primary: {sx: {fontStyle: 'italic'}}}}
                />
            </MenuItem>
        </Menu>
    );
}
